import { Spacing } from '@doordash/design-language';

var ARROW_SIZE = 6;
var SPACING_FROM_NEAREST_CORNER = Spacing.XSmall;
var SPACING_FROM_ANCHOR = Spacing.XxSmall;

export { ARROW_SIZE, SPACING_FROM_ANCHOR, SPACING_FROM_NEAREST_CORNER };
